module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Extrabld.c70e222df9592ff45dd2ad5e08ff5cfd.woff";